import React, { useState, useEffect } from "react";
import styles from "./ManagePermissions.module.scss";

import SupportTeamPermissionsTab from "./components/support/SupportTeamPermissionsTab";
import UserPermissionsTab from "./components/user/UserPermissionsTab";
import { toast } from "react-toastify";
import Axios from "../../../_services/caller.service";

import LevelsTab from "./components/LevelsTab";

const PermissionsManager = () => {
  const [activeTab, setActiveTab] = useState("user");

  useEffect(() => {
    const fetchPermissionsUsers = async () => {
      try {
        await Axios.get("/syncAllPermissionsUsers");
        toast.success("Utilisateurs WordPress synchronisés");
      } catch (err) {
        console.error("Erreur synchronisation WordPress :", err);
      }
    };

    fetchPermissionsUsers();
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>🔐 Gestion des permissions</h2>

      <div className={styles.tabBar}>
        <button
          onClick={() => setActiveTab("support")}
          className={activeTab === "support" ? styles.activeTab : ""}
        >
          Niveaux de support
        </button>
        <button
          onClick={() => setActiveTab("supportTeam")}
          className={activeTab === "supportTeam" ? styles.activeTab : ""}
        >
          Support Team
        </button>
        <button
          onClick={() => setActiveTab("group")}
          className={activeTab === "group" ? styles.activeTab : ""}
        >
          Niveaux de groupe
        </button>
        <button
          onClick={() => setActiveTab("user")}
          className={activeTab === "user" ? styles.activeTab : ""}
        >
          Utilisateurs
        </button>
      </div>

      {activeTab === "support" && <LevelsTab role="support" />}
      {activeTab === "supportTeam" && <SupportTeamPermissionsTab />}
      {activeTab === "group" && <LevelsTab role="user" />}
      {activeTab === "user" && <UserPermissionsTab />}
    </div>
  );
};

export default PermissionsManager;
